import React from "react";

const steps = [
  {
    n: "01",
    title: "Discovery Call",
    body: "A confidential conversation to scope your portfolio, jurisdictions, and objectives. No fee, no commitment.",
  },
  {
    n: "02",
    title: "Customised Blueprint",
    body: "A written engagement with data-driven yield, spatial, and compliance recommendations specific to each asset.",
  },
  {
    n: "03",
    title: "Expert Execution",
    body: "We coordinate vendors, contractors, and PropTech rollouts remotely — auditing every milestone on your behalf.",
  },
  {
    n: "04",
    title: "Performance Reporting",
    body: "Recurring audits, occupancy and yield dashboards, and quarterly portfolio reviews to refine strategy.",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-32 bg-[#F9F8F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <span className="text-xs uppercase tracking-[0.28em] text-[#6E5A4E]">How it Works</span>
          <h2 className="font-serif-display mt-6 text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-[#2B211A] leading-[1.05]">
            A transparent, four-step <span className="italic text-[#8C735D]">engagement</span>.
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12 relative">
          {/* Connector line on lg */}
          <div className="hidden lg:block absolute top-7 left-[6%] right-[6%] h-px bg-[#D6CDBB]" />
          {steps.map((s, i) => (
            <div key={s.n} data-testid={`process-step-${i}`} className="relative">
              <div className="flex items-center gap-4">
                <span className="font-serif-display text-[64px] leading-none text-[#2B211A]">
                  {s.n}
                </span>
                <span className="w-2 h-2 rounded-full bg-[#8C735D] shrink-0" />
              </div>
              <h3 className="font-serif-display mt-5 text-2xl text-[#2B211A]">{s.title}</h3>
              <p className="mt-3 text-[#6E5A4E] leading-relaxed text-[15px]">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
